// FRW review engine — form open/submit + show-more handler.
// Loaded via stylesheets.liquid (deferred). Each IIFE no-ops without its target element.


(function(){
  var API='https://ecomskillfarm.xyz/api/reviews/submit';
  var btn=document.getElementById('frw-write-review-btn');
  var wrap=document.getElementById('frw-review-form-wrap');
  var form=document.getElementById('frw-review-form');
  var cancel=document.getElementById('frw-cancel-review');
  var msg=document.getElementById('frw-review-msg');
  var ratingInput=document.getElementById('frw-rating-input');
  var selectedRating=0;

  if(!btn||!form)return;

  btn.addEventListener('click',function(){
    wrap.style.display='block';
    btn.style.display='none';
    wrap.scrollIntoView({behavior:'smooth',block:'center'});
  });

  cancel.addEventListener('click',function(){
    wrap.style.display='none';
    btn.style.display='inline-block';
  });

  // Star rating picker
  var stars=document.querySelectorAll('.frw-reviews__form-star');
  stars.forEach(function(star){
    star.addEventListener('click',function(){
      selectedRating=parseInt(this.getAttribute('data-rating'));
      ratingInput.value=selectedRating;
      stars.forEach(function(s){
        var r=parseInt(s.getAttribute('data-rating'));
        s.classList.toggle('active',r<=selectedRating);
      });
    });
    star.addEventListener('mouseenter',function(){
      var hover=parseInt(this.getAttribute('data-rating'));
      stars.forEach(function(s){
        var r=parseInt(s.getAttribute('data-rating'));
        s.querySelector('svg').style.fill=r<=hover?'#E040FB':'rgba(255,255,255,.15)';
      });
    });
  });
  document.querySelector('.frw-reviews__form-stars').addEventListener('mouseleave',function(){
    stars.forEach(function(s){
      var r=parseInt(s.getAttribute('data-rating'));
      s.querySelector('svg').style.fill=r<=selectedRating?'#E040FB':'rgba(255,255,255,.15)';
    });
  });

  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(!selectedRating){
      showMsg('Please select a star rating','error');return;
    }
    var submitBtn=document.getElementById('frw-submit-review');
    submitBtn.disabled=true;
    submitBtn.textContent='Submitting...';

    var fd=new FormData(form);
    fetch(API,{method:'POST',body:fd})
      .then(function(r){return r.json()})
      .then(function(data){
        if(data.success){
          var earned=data.glow_earned||0;
          showMsg('Thanks! Your review helps the rave fam. You earned +'+earned+' Glow.','success');
          form.reset();
          selectedRating=0;
          stars.forEach(function(s){s.classList.remove('active')});
          submitBtn.textContent='Submitted!';
        }else{
          showMsg(data.error||'Something went wrong. Try again.','error');
          submitBtn.disabled=false;
          submitBtn.textContent='Submit Review';
        }
      })
      .catch(function(){
        showMsg('Connection error. Check your internet and try again.','error');
        submitBtn.disabled=false;
        submitBtn.textContent='Submit Review';
      });
  });

  function showMsg(text,type){
    msg.style.display='block';
    msg.textContent=text;
    msg.className='frw-reviews__form-msg frw-reviews__form-msg--'+type;
  }

  // Auto-open and pre-fill from URL params (email review requests)
  // Link format: /products/handle#write-review?rating=5&name=Sarah%20M.&email=s@e.com
  var hash=window.location.hash;
  if(hash.indexOf('#write-review')===0){
    var qs=hash.indexOf('?')>-1?hash.substring(hash.indexOf('?')+1):'';
    var params=new URLSearchParams(qs);
    var preRating=parseInt(params.get('rating'));
    if(preRating>=1&&preRating<=5){
      selectedRating=preRating;
      ratingInput.value=preRating;
      stars.forEach(function(s){
        s.classList.toggle('active',parseInt(s.getAttribute('data-rating'))<=preRating);
      });
    }
    var preName=params.get('name');
    var preEmail=params.get('email');
    if(preName){document.getElementById('frw-reviewer-name').value=decodeURIComponent(preName);}
    if(preEmail){document.getElementById('frw-reviewer-email').value=decodeURIComponent(preEmail);}
    btn.click();
    setTimeout(function(){
      var formEl=document.getElementById('frw-review-form-wrap');
      if(formEl)formEl.scrollIntoView({behavior:'smooth',block:'start'});
    },150);
  }
})();

(function(){
  var btn=document.getElementById('frw-show-more');
  if(!btn)return;
  btn.addEventListener('click',function(){
    var hidden=document.querySelectorAll('.frw-reviews__card--hidden');
    hidden.forEach(function(el){el.classList.remove('frw-reviews__card--hidden')});
    btn.style.display='none';
  });
})();
